module.exports = __webpack_public_path__ + "b5a7d6c8848e68b10f039e24d4bfeaea.svg";